import script from "./object_modal.vue?vue&type=script&setup=true&lang=js"
export * from "./object_modal.vue?vue&type=script&setup=true&lang=js"

import "./object_modal.vue?vue&type=style&index=0&id=2aa4094c&lang=scss&scoped=true"

import exportComponent from "/home/steffen/Projekte/clubadmin/frontend/homepage/gc-schoenbuch/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2aa4094c"]])

export default __exports__